import React, { useEffect } from 'react';
import CoachingConstants from 'coaching/CoachingConstants';
import EventTracking from 'lib/EventTracking';
import Image from 'components/Image';
import Link from 'components/Link';
import Text from 'components/Text';
import NavigationListCoachingStreamItem from './NavigationListCoachingStreamItem';
import { NavigationList_me_navigationSections_items_CoachingStream } from 'queries/__generated__/NavigationList';
import CoachingAvatar from 'assets/images/coaching/coaching_avatar.svg';

import './styles/NavigationListCoachingSection.scss';

export type CoachingSectionKey = 'coachingCoachStreams' | 'coachingParticipantStreams';

export type Props = {
  sectionKey: CoachingSectionKey;
  items: NavigationList_me_navigationSections_items_CoachingStream[];
};

export default function NavigationListCoachingSection({ sectionKey, items }: Props) {
  useEffect(() => EventTracking.trackKey('coaching.nav_list.coaching_dashboard_item.view'), []);

  const mapSectionKeyToLinkProps = {
    coachingCoachStreams: {
      to: CoachingConstants.COACHING_SCHEDULE_ROUTE,
      eventKey: 'coaching.coach_dashboard.click',
    },
    coachingParticipantStreams: { to: CoachingConstants.COACHING_HOME_ROUTE },
  };
  const mapKeyToLabel = {
    coachingCoachStreams: 'Tutor dashboard',
    coachingParticipantStreams: 'Remind Tutoring',
  };

  return (
    <section className="NavigationList-section">
      <li className="NavigationListCoachingSection-header">
        <Link
          {...mapSectionKeyToLinkProps[sectionKey]}
          data-test="navigation-coaching-section-header-link"
          color="inherit"
          activeClassName="active"
          className="NavigationListCoachingSection-header-link">
          <div className="NavigationListCoachingSection-header-container">
            <Image
              src={CoachingAvatar}
              width={16}
              className="NavigationListCoachingSection-header-avatar"
            />
            <Text
              size="xsmall"
              color="chalkboard"
              className="NavigationListCoachingSection-header-name">
              {mapKeyToLabel[sectionKey]}
            </Text>
          </div>
        </Link>
      </li>
      {items?.map(i => (
        <NavigationListCoachingStreamItem key={i.uuid} coachingStream={i} />
      ))}
    </section>
  );
}
